<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex with-media">
          <div class="p-2 w-70">
            <div class="media">
              <img src="/static/img/user@3x.png" class="avatar" />
              <div class="media-body">
                <h5>{{userInfo.user_name}}  <span class="badge rose align-middle">{{userInfo.cate_code_name}}</span></h5>
                <p><span class="gray">클래스</span> <strong>{{userInfo.class_name}}</strong></p>
              </div>
            </div>
          </div>
          <div class="p-2 ml-auto button-group">
            <button type="button" class="btn btn-secondary" @click="handleCommand('download')">PDF 저장</button>
            <button type="button" class="btn mint" @click="handleCommand('send')">알림톡 전송</button>
          </div>
        </div>
      </div>
    </div>

    <div class="grade-read-times">
      <div class="card second-card">
        <div class="card-body el-tabs__content">
          <div class="d-flex">
            <div class="p-2">
              <h2>회독 성적표</h2>
            </div>
            <div class="p-2 ml-auto">
              <!-- <el-button class="pdf circle" type="primary" :loading="pdfLoading" @click="makePDF('.print-grade-read-times')"><i class="fas fa-file-pdf"></i></el-button> -->
            </div>
          </div>

          <div class="d-flex blue-gray">
            <div class="p-2">
              <h1>{{userInfo.book_name}}</h1>
              <p>
                <!-- <span class="gray">전체평균</span> <span class="number">{{userInfo.avg_score}}</span>
                · <span class="gray">최고점수</span> <span class="number">{{userInfo.exam_score_max}}</span>
                · <span class="gray">최저점수</span> <span class="number">{{userInfo.exam_score_min}}</span> -->
              </p>
            </div>
          </div>

          <el-row :gutter="40">
            <el-col :span="12">
              <fieldset>
                <div class="d-flex">
                  <div class="p-2">
                    <h2>성적 분석</h2>
                  </div>
                  <div class="p-2">
                    <strong><span class="number mint"></span></strong>
                  </div>
                </div>
                <stone-data-table
                  ref="groupTimesTable"
                  :loading="searchLoading"
                  :columns="groupTimesColumns"
                  :data="groupTimesData"
                  :table-props="timesTableProps"
                  :page-size="emptyPageSize"
                  :pagination-props="emptyPaginationProps">
                </stone-data-table>
              </fieldset>
            </el-col>
            <el-col :span="12">
              <fieldset>
                <div class="d-flex">
                  <div class="p-2">
                    <h2>취약유형 분석</h2>
                  </div>
                  <div class="p-2">
                    <strong><span class="number mint"></span></strong>
                  </div>
                </div>
                <stone-data-table
                  :loading="searchLoading"
                  :columns="groupWrongColumns"
                  :data="quizWrongData"
                  :table-props="quizTableProps"
                  :page-size="emptyPageSize"
                  :pagination-props="emptyPaginationProps">
                </stone-data-table>
              </fieldset>
            </el-col>
          </el-row>

          <fieldset v-if="lineVisible">
            <div class="d-flex">
              <div class="p-2">
                <h2>성적 변화 그래프</h2>
              </div>
              <div class="p-2 ml-auto">
                <template v-for="legend in lineLegend">
                  <svg height="24" width="12" :key="legend.prop">
                    <circle cx="6" cy="19" r="4px" :fill="legend.legendColor" />
                  </svg> {{legend.label}}
                </template>
              </div>
            </div>
            <line-chart :chart-data="lineChartData" :height="lineChartHeight" :options="lineChartOptions" :styles="lineChartStyles"></line-chart>
          </fieldset>

          <fieldset>
            <h2>선생님 의견</h2>
            <el-input type="textarea" :rows="5" v-model.trim="userInfo.exam_comment" placeholder="코멘트를 입력하십시오."></el-input>
            <div class="text-right mt-2">
              <button class="btn mint" type="primary" v-show="commentVisible" @click="saveComment">저장</button>
            </div>
          </fieldset>
        </div>
      </div>
    </div>

    <!-- PDF Dialog-->
    <el-dialog title="성적표" width="1200px" :visible.sync="dialogTableVisible" append-to-body>
      <div class="pdf-file">
      <div class="card-body text-right">
        <!-- <el-button type="primary" :loading="pdfLoading" @click="handlePDF"><i class="fa fa-download"></i> 성적표 저장</el-button> -->
        <el-button class="pdf circle" type="primary" :loading="pdfLoading" @click="handlePDF"><i class="fas fa-file-pdf"></i></el-button>
      </div>
      <div class="print-grade-read-times">
        <div class="card">
          <div class="card-body">
            <div class="media logo">
                <img src="/static/img/logo_notext.png" />
                <div class="media-body">
                  <h2>회독 성적표</h2>
                </div>
            </div>
            <div class="d-flex with-media">
              <div class="p-2 w-100">
                <div class="media">
                  <img src="/static/img/user@3x.png" class="avatar" />
                  <div class="media-body">
                    <h5>{{userInfo.user_name}}  <span class="badge rose align-middle">{{userInfo.cate_code_name}}</span></h5>
                    <p><span class="gray">클래스</span> <strong>{{userInfo.class_name}}</strong></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="card second-card">
            <div class="card-body el-tabs__content">
              <div class="d-flex blue-gray">
                <div class="p-2">
                  <h1>{{userInfo.book_name}}</h1>
                  <p>
                    <!-- <span class="gray">전체평균</span> <span class="number">{{userInfo.avg_score}}</span>
                    · <span class="gray">최고점수</span> <span class="number">{{userInfo.exam_score_max}}</span>
                    · <span class="gray">최저점수</span> <span class="number">{{userInfo.exam_score_min}}</span> -->
                  </p>
                </div>
              </div>

              <el-row :gutter="40">
                <el-col :span="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>성적 분석</h2>
                      </div>
                      <div class="p-2">
                        <strong><span class="number mint"></span></strong>
                      </div>
                    </div>
                    <stone-data-table
                      ref="groupTimesTablePDF"
                      :loading="searchLoading"
                      :columns="groupTimesColumns"
                      :data="groupTimesData"
                      :table-props="timesTableProps"
                      :page-size="emptyPageSize"
                      :pagination-props="emptyPaginationProps">
                    </stone-data-table>
                  </fieldset>
                </el-col>
                <el-col :span="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>취약유형 분석</h2>
                      </div>
                      <div class="p-2">
                        <strong><span class="number mint"></span></strong>
                      </div>
                    </div>
                    <stone-data-table
                      :loading="searchLoading"
                      :columns="groupWrongColumns"
                      :data="quizWrongData"
                      :table-props="quizTableProps"
                      :page-size="emptyPageSize"
                      :pagination-props="emptyPaginationProps">
                    </stone-data-table>
                  </fieldset>
                </el-col>
              </el-row>

              <fieldset v-if="lineVisible">
                <div class="d-flex">
                  <div class="p-2">
                    <h2>성적 변화 그래프</h2>
                  </div>
                  <div class="p-2 ml-auto">
                    <template v-for="legend in lineLegend">
                      <svg height="24" width="12" :key="legend.prop">
                        <circle cx="6" cy="19" r="4px" :fill="legend.legendColor" />
                      </svg> {{legend.label}}
                    </template>
                  </div>
                </div>
                <line-chart :chart-data="lineChartData" :height="lineChartHeight" :options="lineChartOptions" :styles="lineChartStyles"></line-chart>
              </fieldset>

              <fieldset>
                <h2>선생님 의견</h2>
                <div v-html="replaceCarriageReturnToBr(userInfo.exam_comment)"></div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import common from '@/modules/common'
import LineChart from '@/components/chart/Line.js'
import pdf from '@/modules/pdf'

export default {
  name: 'M060303',
  components: {LineChart},
  mixins: [common.mixins, pdf],
  data () {
    return {
      pdfLoading: false,
      commentVisible: true,
      lineVisible: true,
      dialogTableVisible: false,
      userInfo: {
        book_seq: 0,
        class_seq: 0,
        class_user_seq: 0,
        class_name: '',
        cate_code_name: '',
        user_id: '',
        user_name: '',
        book_name: '',
        exam_comment: '',
        phone: ''
      },
      timesTableProps: {showSummary: true, sumText: '합계', sortable: false, summaryMethod: this.getSummariesTimes, spanMethod: this.objectSpanMethod},
      groupTimesData: [],
      groupTimesColumns: [
        {label: '회차', prop: 'exam_times_name', align: 'center', fixed: 'left', width: 70},
        {label: '영역', prop: 'cate_code_name', align: 'center', fixed: 'left', class: 'exam-type-cell', width: 70},
        {label: '배점', prop: 'm0_group_score_sum', align: 'center', class: 'number', width: 60},
        {label: '', prop: 'm0_group_score', align: 'center', class: 'number', alies: 'm0', legendColor: '#00aec0', width: 60},
        {label: '', prop: 'm1_group_score', align: 'center', class: 'number', alies: 'm1', legendColor: '#292955', width: 60},
        {label: '', prop: 'm2_group_score', align: 'center', class: 'number', alies: 'm2', legendColor: '#b874d3', width: 60},
        {label: '', prop: 'm3_group_score', align: 'center', class: 'number', alies: 'm3', legendColor: '#e5a03e', width: 60}
      ],
      groupWrongColumns: [
        {label: 'No', align: 'center', type: 'index', width: 40},
        {label: '영역', prop: 'group_name', align: 'center', width: 50},
        {label: '내용', prop: 'cate_path', align: 'left', width: 200}
      ],
      quizWrongData: [],
      quizTableProps: {showHeader: false, sortable: false},
      lineChartData: [],
      lineLegend: [],
      lineChartHeight: 200,
      param: {},
      lineChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {left: 10, right: 10, top: 20, bottom: 10}
        },
        legend: {display: false},
        scales: {
          yAxes: [
            {ticks: {min: 0, padding: 20}, stacked: false, beginAtZero: true}
          ],
          xAxes: [
            {gridLines: {display: false}}
          ]
        }
      }
    }
  },
  computed: {
    lineChartStyles () {
      return {
        height: `${this.lineChartHeight}px`,
        position: 'relative'
      }
    }
  },
  beforeCreate () {
  },
  created () {
    if (this.$route.params) {
      this.param = {
        book_seq: this.getToNumber(this.$route.params.book_seq),
        class_seq: this.getToNumber(this.$route.params.class_seq),
        class_user_seq: this.getToNumber(this.$route.params.class_user_seq)
      }
      this.loadInfo()
      this.loadExamReadGrade()
    } else {
      this.$router.push({name: 'M060302'})
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  methods: {
    handleWindowResize () {
      this.$refs.groupTimesTable.$refs.stoneDataTable.$refs.elTable.doLayout()
    },
    loadInfo () {
      // 사용자 정보
      common.axios.post('/class/user/load', this.param)
        .then(response => {
          const result = response.data
          // console.log('loadInfo result : ', result)
          Object.keys(this.userInfo).forEach(key => {
            this.userInfo[key] = result[key]
          })
        })
    },
    loadExamReadGrade () {
      // 회독 성적표
      common.axios.post('/grade/read/times', this.param)
        .then(response => {
          const result = response.data
          // console.log('loadExamReadGrade result : ', result)
          if (result.exam_group) {
            const obj = result.exam_group[0]
            this.lineLegend = []
            this.groupTimesColumns.map(x => {
              if (x.alies) {
                Object.keys(obj).forEach(key => {
                  if (x.prop === key) {
                    x.label = obj[x.alies + '_title']
                    if (x.label) {
                      this.lineLegend.push(x)
                    }
                  }
                })
              }
            })
            let oldTimes = 0
            let isRowSpan = false
            result.exam_group.map(item => {
              isRowSpan = oldTimes !== item.exam_times
              item.times_group_count = isRowSpan ? item.times_group_count : 0
              oldTimes = item.exam_times
            })
            this.$nextTick(() => {
              this.groupTimesData = result.exam_group
              this.lineChartData = this.getLineChartData(result.exam_group)
            })
          }

          this.quizWrongData = result.exam_wrong
          if (this.quizWrongData.length < 10) {
            for (let i = this.quizWrongData.length; i < 10; i++) {
              this.quizWrongData.push({group_name: '', cate_path: ''})
            }
          }

          if (result.exam_comment) {
            this.userInfo.exam_comment = result.exam_comment.exam_comment
          }
        })
    },
    getSummariesTimes (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '총점'
          return
        } else if (index === 1) {
          sums[index] = ''
          return
        }
        if (!column.label) {
          sums[index] = ''
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    saveComment () {
      common.axios.post('/grade/read/comment', this.userInfo)
        .then(response => {
          if (response.data.status === 1) {
            this.$message('코멘트가 등록되었습니다.')
          }
        })
    },
    getLineChartData (value) {
      const labels = []
      const datasets1 = []
      const datasets2 = []
      const datasets3 = []
      const datasets4 = []
      const timesMap = {}
      value.map(x => {
        timesMap[x.exam_times] = x.exam_times_name
      })
      Object.keys(timesMap).forEach(key => {
        labels.push(timesMap[key])
        datasets1.push(this.getTimesTotal(value, key, 'm0_group_score'))
        datasets2.push(this.getTimesTotal(value, key, 'm1_group_score'))
        datasets3.push(this.getTimesTotal(value, key, 'm2_group_score'))
        datasets4.push(this.getTimesTotal(value, key, 'm3_group_score'))
      })
      // console.log('datasets1 : ', datasets1)
      // console.log('datasets2 : ', datasets2)
      // console.log('datasets3 : ', datasets3)
      // console.log('datasets4 : ', datasets4)
      const datasets = []
      const exam = value[0]
      if (exam.m0_title) {
        datasets.push(this.getLineChartDataSet(exam.m0_title, '#00aec0', datasets1))
      }
      if (exam.m1_title) {
        datasets.push(this.getLineChartDataSet(exam.m1_title, '#292955', datasets2))
      }
      if (exam.m2_title) {
        datasets.push(this.getLineChartDataSet(exam.m2_title, '#b874d3', datasets3))
      }
      if (exam.m3_title) {
        datasets.push(this.getLineChartDataSet(exam.m3_title, '#e5a03e', datasets4))
      }
      return {labels: labels, datasets: datasets}
    },
    getLineChartDataSet (label, color, data) {
      return {
        label: label,
        borderColor: color,
        fill: false,
        radius: 4,
        pointRadius: 4,
        pointBorderWidth: 2,
        pointBackgroundColor: color,
        pointBorderColor: color,
        pointHoverRadius: 5,
        data: data
      }
    },
    getTimesTotal (data, key, prop) {
      const keyValues = data.filter(item => item.exam_times === Number(key))
      const values = keyValues.map(item => item[prop])
      let result = 0
      if (!values.every(value => isNaN(value))) {
        result = values.reduce((prev, curr) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + curr
          } else {
            return prev
          }
        }, 0)
      }
      return result
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {rowspan: row.times_group_count, colspan: row.times_group_count === 0 ? 0 : 1}
      }
    },
    handleCommand (command) {
      if (command === 'send') {
        this.sendGrade()
      } else if (command === 'refresh') {
        this.loadExamReadGrade()
      } else if (command === 'download') {
        this.dialogTableVisible = true
        this.$nextTick(() => {
          // this.$refs.printDialog.loadExamUserComment()
        })
      }
    },
    sendGrade () {
      this.userInfo.class_user_name = this.userInfo.user_name
      common.axios.post('/exam/kakao/book', {seq: this.userInfo.book_seq, title: this.userInfo.book_name, users: [this.userInfo]})
        .then(response => {
          const result = response.data
          if (result.status === 1) {
            this.$message('성적표가 발송되었습니다.')
          } else {
            this.$message.warning(result.message)
          }
        })
    },
    handlePDF () {
      this.makePDF('.print-grade-read-times')
    },
    makePDF (selector) {
      this.pdfLoading = true
      this.commentVisible = false
      this.$nextTick(() => {
        this.exportPDF(selector, `회독_${this.userInfo.user_name}_${this.userInfo.book_name}`)
      })
    }
  }
}
</script>

<style>
.exam-type-cell {
  background-color: #FAFAFA !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/M060303.vue